export const JOB_TYPES = {
  MANUAL: 'manually',
  AUTOMATIC: 'automatically',
  AMC: 'amc',
  LENDER_CHOICE: 'lender_choice',
  VA: 'va',
  REVIEW: 'review',
}
